<!--  -->
<template>
  <div class="active-success">
    <van-popup
      v-model="show"
      position="center"
      :style="{ height: '250px', width: '275px' }"
      duration="0.18"
      round
    >
      <van-icon @click="show = false" name="cross" />
      <img class="icon" src="@/assets/img/personalCenter/active-success.png" alt="" />
      <p class="name">激活成功</p>
      <button class="btn" @click="myCourse">查看我的课程</button>
    </van-popup>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      show: false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    myCourse() {
      if (this.$root.$data.isApp) {
        this.$sendToApp('goLearnCenterPage', {}, false);
      } else {
        this.$router.push({ path: '/personalCenter/mycourseList' });
      }
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.active-success {
  // padding: 20px 0 0 0;
  ::v-deep .van-popup--center.van-popup--round {
    border-radius: 8px !important;
  }
  ::v-deep .van-icon {
    position: absolute;
    top: 14px;
    right: 14px;
    color: #333;
    font-size: 24px;
  }
  .icon {
    display: block;
    width: 96px;
    margin: 100px auto 0;
  }
  .name {
    padding: 44px 0;
    color: #333;
    font-weight: 600;
    font-size: 32px;
    text-align: center;
  }
  .btn {
    display: block;
    width: 362px;
    height: 80px;
    margin: 0 auto;
    color: #fff;
    font-weight: 600;
    font-size: 32px;
    background: #ff6c02;
    border-radius: 50px;
  }
}
</style>
